// extracted by mini-css-extract-plugin
export var orderDetails = "_oj-2";
export var orderImage = "_oj-1";
export var orderMeta = "_oj-3";
export var orderSummary = "_oj-0";
export var rightArrow = "_oj-4";